<main class="ma__form-page" id="main-content" tabindex="-1">
  <div class="main-content main-content--two page-container" [formGroup]="searchFields">
    <section>
      <!--<div class="ma__collapsible-header__title" style="display:inline;">&nbsp;Search</div>-->
      <h3>Search for Waste Site & Reportable Releases</h3>
      <div class="form-row" *ngFor="let items of formItems;">
        <ng-container *ngFor="let item of items">
          <ng-container *ngIf="item.iterable != true;">
            <app-control class="{{item.width}}" [property]="item" [form]="searchFields"></app-control>
          </ng-container>
        </ng-container>
      </div>
      <!-- <div class="form-group">  
        <div class="input-group">  
            <input class="form-control" *ngIf="flag"  [formGroup]="searchFields.selectRTN"  type="text"  (keyup)="searchClient(selectRTN)" />  
            <input class="form-control" [formGroup]="searchFields.selectRTN"   disabled *ngIf="!flag" type="text" />  
              
        </div>          
    </div>  
    <div class="search-result" *ngIf="flag">  
        <ul>  
            <li *ngFor="let rtnItem of listofRTN | async">  
                <a (click)="onselectClient(rtnItem)">{{rtnItem}}</a>  
            </li>             
        </ul>  
    </div>  -->
      <div class="row">
        <div class="col-md-12">
          <button class="btn btn-primary float-right" style="margin-top:20px;" (click)="viewerSearch()" type="submit" value="submit search"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path style="fill:currentColor;" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>&nbsp;Search</button>

          <button class="btn btn-default float-left" style="margin-top:20px;height:45px" (click)="back()"><i class="fa fa-chevron-left"></i>&nbsp;Previous</button>
          <button class="btn btn-default float-left" style="margin-top:20px;" type="reset" (click)="clearSearchFields()">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="redo" class="svg-inline--fa fa-redo fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z"></path>
            </svg>&nbsp;Clear
          </button>
        </div>
      </div>
      <br>
      <div class="float-right">
        <span>Please contact <a href="mailto:BWSC.eDEP@mass.gov">BWSC.eDEP@mass.gov</a> with questions.   </span><br>
        <span class="float-right">Data is updated once a day</span>
      </div>
    </section>
    <ngx-spinner bdColor="rgba(51, 51, 51, 1.0)" size="default" type="ball-spin-clockwise">
      <p style="color: white">Please Wait. </p>
    </ngx-spinner>
  </div>

  
</main>
